export function getYoutubeIdFromUrl(url) {
  if (!url || typeof url !== "string") {
    return "";
  }

  url = url.trim();

  const patterns = {
    shortUrl: /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]{11})(?:\?.*)?/,
    watchUrl: /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})(?:&.*)?/,
    embedUrl: /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})(?:\?.*)?/,
    mobileUrl: /(?:https?:\/\/)?m\.youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})(?:&.*)?/,
    videoIdOnly: /^[a-zA-Z0-9_-]{11}$/,
  };
  const isValidYouTubeUrl = Object.values(patterns).some((pattern) =>
    pattern.test(url)
  );
  if (!isValidYouTubeUrl) {
    return "";
  }
  for (const pattern of Object.values(patterns)) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  if (patterns.videoIdOnly.test(url)) {
    return url;
  }
  return "";
}
